$.module('MM.ui.component', function () {
  /**
   * 渲染 select 组件 的密码输入框
   * @param {} options
   * @param $wrapper 需要挂载的dom节点 支持 输入选择器或者dom元素
   * @param placeholder 输入框的 placeholder展示文字
   * @param options select的所有选项
   * @param name input 的name 属性值
   * @param onChange(val, text, index) 点击 select option时的回调，参数别为所点击选项的 值，文字，索引
   * @returns ui组件
   */
  function _renderFormSelect(options) {
    if (!options.$wrapper) return;

    var $wrapper = $(options.$wrapper);

    options = _.assign(
      {
        placeholder: '请选择',
        options: {},
        name: 'select',
        onChange: undefined,
      },
      options,
    );

    var tmpl =
      '<div class="ui-form-select">\
                <input class="ui-form-input" disabled type="text" value=""  placeholder="<%= placeholder %>"/>\
                <input type="hidden" name="<%= name %>"  />\
                <ul class="ui-form-options ui-hide">\
                    <% for(var val in options) { %>\
                        <li data-val="<%= val %>"><%= options[val] %></li>\
                    <% } %>\
                </ul>\
            </div>';

    $wrapper.html($.template(tmpl, options));

    $wrapper
      .on('click', '.ui-form-select', function () {
        $wrapper.find('.ui-form-options').toggleClass('ui-hide');
      })
      .on('mouseleave', '.ui-form-options', function () {
        $wrapper.find('.ui-form-options').addClass('ui-hide');
      })
      .on('click', 'li', function () {
        var $this = $(this);
        var val = $this.data('val');
        $wrapper.find('.ui-form-input').val($this.text());
        $wrapper.find('input[type="hidden"]').val(val);
        options.onChange && options.onChange(val, $this.text(), $this.index());
      });
  }

  /**
   * 渲染 可以点击 显示隐藏 的密码输入框
   * @param {} options
   * @param $wrapper 需要挂载的dom节点 支持 输入选择器或者dom元素
   * @param placeholder 输入框的 placeholder展示文字
   * @param name input 的name 属性值
   * @returns ui组件
   */
  function _renderPasswordInput(options) {
    if (_.isArray(options)) {
      // 如果options为数组
      options.forEach(function (item) {
        _renderPasswordInput(item);
      });
      return;
    }

    var $wrapper = $(options.$wrapper);

    if (!$wrapper) return;

    options = _.assign(
      {
        placeholder: '设置密码（需包含数字和字母，8-20位）',
        name: 'pwd',
      },
      options,
    );

    var tmpl =
      '<input class="ui-form-input ui-form-password" onfocus="this.type=\'password\'" autocomplete="off" placeholder="<%= placeholder %>" name="<%= name %>" />\
            <span class="ui-form-password-addon iconfont icon-yincang- inline" title="显示密码"></span>';

    $wrapper.html($.template(tmpl, options));

    $wrapper.delegate('.ui-form-password-addon', 'click', function (e) {
      var $this = $(this);
      var $input = $this.siblings('input');

      if ($this.hasClass('icon-yincang-')) {
        $input.prop('type', 'text');
        $this
          .removeClass('icon-yincang-')
          .addClass('icon-xianshi-')
          .attr('title', '隐藏密码');
      } else {
        $input.prop('type', 'password');
        $this
          .addClass('icon-yincang-')
          .removeClass('icon-xianshi-')
          .attr('title', '显示密码');
      }
    });

    options.appendCallback && options.appendCallback($wrapper);
  }

  return {
    renderPasswordInput: _renderPasswordInput,
    renderFormSelect: _renderFormSelect,
  };
});
